import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: 'Tomo 1 — ENTENDER SU CEREBRO',
  desc: 'La base científica explicada en lenguaje de padre. Por qué tu hijo actúa así, cómo funciona su cerebro diferente y cómo dejar de culparle (y culparte) para empezar a ayudarle de verdad.'
}, {
  icon: '📗',
  title: 'Tomo 2 — DOMAR LA IMPULSIVIDAD',
  desc: 'Técnicas de regulación emocional probadas para frenar las explosiones antes de que ocurran. Protocolos paso a paso para las crisis más comunes: rabietas, golpes, gritos y negativas.'
}, {
  icon: '📙',
  title: 'Tomo 3 — RUTINAS SIN GUERRA',
  desc: 'Cómo diseñar una rutina de mañana y tarde que tu hijo con TDAH realmente cumpla. Sistema de hábitos adaptado al cerebro impulsivo para que el caos diario desaparezca para siempre.'
}, {
  icon: '📕',
  title: 'Tomo 4 — ENFOQUE SIN PELEAS',
  desc: 'El sistema de dopamina para que los deberes dejen de ser una batalla. Técnicas de concentración, gestión del tiempo y motivación adaptadas específicamente al cerebro TDAH.'
}, {
  icon: '📓',
  title: 'Tomo 5 — RECUPERAR EL VÍNCULO',
  desc: 'Sanar la relación dañada por años de incomprensión. Cómo volver a disfrutar de tu hijo, eliminar la culpa y construir una conexión emocional sólida que lo proteja toda la vida.'
}];
const includes = ['Protocolos 100% listos — abres el PDF y lo aplicas hoy mismo', 'Explicación científica en lenguaje de padre (sin tecnicismos)', 'Pasos exactos para cada situación de crisis', 'Fichas de seguimiento y progresión semanal', 'Adaptado a la realidad de las familias españolas'];
export function ProductOverview() {
  return <section className="bg-navy text-white py-12 px-6 relative" data-id="element-307">
      <div className="max-w-5xl mx-auto" data-id="element-308">
        <div className="text-center mb-8" data-id="element-309">
          <h2 className="text-gold font-display text-xl md:text-2xl font-bold tracking-widest uppercase mb-2" data-id="element-310">
            🏆 CHERUB AGENCY™ MEGAPACK TDAH
          </h2>
          <h3 className="font-display text-4xl md:text-5xl font-bold mb-3" data-id="element-311">
            TDAH: GUÍA PARA SALVAR A TU HIJO
          </h3>
          <p className="text-xl text-gray-300" data-id="element-312">
            5 Tomos + 3 Bonos — 300+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="mb-8" data-id="element-313">
          <h4 className="text-2xl font-bold text-center mb-5 text-gold flex items-center justify-center gap-3" data-id="element-314">
            <span className="text-3xl" data-id="element-315">💪</span> 5 TOMOS COMPLETOS
          </h4>
          <div className="grid gap-3" data-id="element-316">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="bg-white/5 border border-white/10 p-4 md:p-6 rounded-2xl flex flex-col md:flex-row gap-4 items-start hover:bg-white/10 transition-colors" data-id="element-317">
                <div className="text-5xl flex-shrink-0 bg-white/10 w-16 h-16 rounded-2xl flex items-center justify-center" data-id="element-318">
                  {tomo.icon}
                </div>
                <div data-id="element-319">
                  <h5 className="font-display text-xl md:text-2xl font-bold text-white mb-1.5" data-id="element-320">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-300 text-lg leading-relaxed" data-id="element-321">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gold/10 border border-gold/30 rounded-2xl p-6 md:p-8" data-id="element-322">
          <h4 className="font-display text-2xl font-bold text-gold mb-4 text-center" data-id="element-323">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-3" data-id="element-324">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-325">
                <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0 bg-white rounded-full" data-id="element-326" />
                <span className="text-lg text-gray-200" data-id="element-327">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}